import React from "react";
import { useTranslation } from "react-i18next";

const EmptyState = () => {
  const { t } = useTranslation();
  return (
    <div className="h-full flex flex-col items-center justify-center text-center text-gray-400">
      <div className="w-24 h-24 mb-4 rounded-full bg-gray-100" />
      <div className="text-base font-semibold">{t("emptyInboxTitle")}</div>
      <div className="text-xs mt-1 max-w-xs">
        {t("emptyInboxSubtitle")}
      </div>
    </div>
  );
};

export default EmptyState;

